import { Fragment } from 'react';

const ImageZoom = Fragment;
export default ImageZoom;
